import React from 'react';
import { CircularProgress } from '@mui/material';
import { FixedSpinner } from 'src/react/_Layout/LoadingSpinner.styles';

export const LoadingSpinner = () => {
  return (
    <FixedSpinner>
      <CircularProgress size={50} />
    </FixedSpinner>
  );
};

export default LoadingSpinner;
